import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconTrashCan: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconTrashCan"><Path fillRule="evenodd" clipRule="evenodd" d="M7.22918 5H2.5V7H4.03211L5.06659 22H18.9334L19.9679 7H21.5V5H16.7708C16.1335 2.97145 14.2395 1.5 12 1.5C9.76053 1.5 7.86654 2.97145 7.22918 5ZM9.40105 5H14.5989C14.0801 4.10329 13.1099 3.5 12 3.5C10.8901 3.5 9.91989 4.10329 9.40105 5ZM11 10V17H9V10H11ZM15 10V17H13V10H15Z" fill="currentColor"/></CentralIconBase>;
});

export default IconTrashCan;
